import 'arrive';
import $ from 'jquery';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { parsePhoneNumber } from "libphonenumber-js";
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/styles';


// "page_pagamento"/"page_payment" sono classi generate dallo slug della pagina (vedi
// add_page_slug_to_the_body in theme-config.php): essendo lo slug tradotto da Polylang
// per ogni lingua ("pagamento" in IT, "payment" in EN...), quel selettore intercettava
// SOLO l'italiano — in inglese l'intero script del checkout non partiva mai. Usiamo la
// classe nativa WooCommerce, sempre presente sulla pagina di checkout indipendentemente
// da slug/lingua.
document.arrive("body.woocommerce-checkout", { existing: true }, function () {
  const $couponToggle = $("#custom-checkout-coupon .coupon-toggle");
  const $couponForm = $("#custom-coupon-form");

  if ($couponToggle.length && $couponForm.length) {
    $couponToggle.on('click', function () {
      const isOpen = $couponForm.is(':visible');
      $couponForm.slideToggle(200);
      $(this).attr('aria-expanded', (!isOpen).toString());
    });
  }

  function scrollToNotices() {
    const $notices = $('#checkout-notices-content');
    if ($notices.length && $notices.children().length) {
      $('html, body').animate({ scrollTop: 0 }, 300);
    }
  }

  function refreshOrderReview() {
    $.ajax({
      type: 'POST',
      url: wc_checkout_params.wc_ajax_url.replace('%%endpoint%%', 'update_order_review'),
      data: {
        security: wc_checkout_params.update_order_review_nonce,
        post_data: $('form.checkout').serialize(),
      },
      success: function (data) {
        if (data && data.fragments) {
          $.each(data.fragments, function (key, value) {
            $(key).replaceWith(value);
          });
        }
      },
    });
  }

  $(document).off('click', '.woocommerce-remove-coupon');
  $(document).on('click', '.woocommerce-remove-coupon', function (e) {
    e.preventDefault();
    const coupon = $(this).data('coupon');

    $.ajax({
      type: 'POST',
      url: wc_checkout_params.wc_ajax_url.replace('%%endpoint%%', 'remove_coupon'),
      data: {
        security: wc_checkout_params.remove_coupon_nonce,
        coupon: coupon,
      },
      success: function (response) {
        $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();
        $('#checkout-notices-content').html(response);
        scrollToNotices();
        refreshOrderReview();
      },
    });
  });

  $(document).on('click', '#custom-checkout-coupon .apply-coupon-btn', function () {
    const code = $('#coupon_code_input').val().trim();
    if (!code) return;

    const $btn = $(this);
    $btn.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: wc_checkout_params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon'),
      data: {
        security: wc_checkout_params.apply_coupon_nonce,
        coupon_code: code,
      },
      success: function (response) {
        $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();
        $('#checkout-notices-content').html(response);
        $('#coupon_code_input').val('');
        scrollToNotices();
        refreshOrderReview();
      },
      complete: function () {
        $btn.prop('disabled', false);
      },
    });
  });

  // Stesso problema di Lenis sui dropdown select2 di Paese/Regione e County (billing e
  // shipping): il loro elenco risultati viene creato/distrutto ad ogni apertura, quindi
  // l'attributo va riapplicato ogni volta all'evento "select2:open" (non basta farlo una
  // volta sola all'avvio come per il dropdown di intl-tel-input).
  $(document).on('select2:open', '#billing_country, #billing_state, #shipping_country, #shipping_state', function () {
    document.querySelectorAll('.select2-container--open .select2-results__options').forEach((el) => {
      el.setAttribute('data-lenis-prevent', '');
    });
  });

  function isShippingDifferent() {
    return $('#ship-to-different-address-checkbox').is(':checked');
  }

  // Legge la lingua dal tag <html> e prende solo i primi due caratteri
  const lang = (document.documentElement.lang || 'en').substring(0, 2);

  // Messaggio di errore del telefono: specifico per paese/prefisso quando li conosciamo,
  // altrimenti un fallback generico (es. nessun paese ancora selezionato).
  const phoneMessages = {
    it: 'Numero di telefono non valido.',
    en: 'Invalid phone number.',
  };
  const phoneErrorMessage = phoneMessages[lang] || phoneMessages.en;

  // --- Telefono dinamico: un campo = un paese di riferimento, indipendenti tra loro ---
  // billing_phone segue billing_country, phone_shipping (aggiunto separatamente col
  // Checkout Field Editor) segue shipping_country. Nessuna priorità/fallback tra i due:
  // ognuno valida solo rispetto al proprio paese.
  //
  // Eccezione voluta: quando "Spedisci a un indirizzo diverso?" è spuntato, il telefono di
  // fatturazione non è quello che il corriere userà per la consegna (lo è phone_shipping),
  // quindi non deve più corrispondere al paese di fatturazione — resta solo un numero
  // valido in generale. Attivata passando relaxCountryMatchWhenShippingDiffers: true.
  function setupDynamicPhoneField(phoneSelector, countrySelector, { relaxCountryMatchWhenShippingDiffers = false } = {}) {
    const phoneInputEl = document.querySelector(phoneSelector);
    if (!phoneInputEl) return null;

    const iti = intlTelInput(phoneInputEl, {
      initialCountry: 'it',
      separateDialCode: true,
    });

    // WooCommerce ha una propria validazione nativa del telefono (classe "validate-phone"),
    // un controllo debolissimo basato solo sui caratteri ammessi, agganciato agli eventi
    // nativi input/change/focusout del campo. Scatta anche quando l'utente sceglie un paese
    // dal menu della bandierina (che genera comunque eventi sul testo del campo) e sovrascrive
    // le NOSTRE classi con l'esito del SUO controllo, molto più permissivo — vanificando la
    // validazione per paese. La rimuoviamo qui: la nostra la sostituisce interamente.
    $(`${phoneSelector}_field`).removeClass('validate-phone');

    // Lenis (smooth scroll) intercetta la rotellina anche dentro al dropdown paesi di
    // intl-tel-input: data-lenis-prevent gli dice di ignorarla su questo elemento.
    // Scoping su .iti (il wrapper generato per QUESTA istanza) perché con due campi
    // telefono in pagina un selettore globale prenderebbe solo il primo dei due dropdown.
    const wrapper = phoneInputEl.closest('.iti');
    const countryList = wrapper ? wrapper.querySelector('.iti__country-list') : null;
    if (countryList) {
      countryList.setAttribute('data-lenis-prevent', '');
    }

    // intl-tel-input forza via JS un padding-left inline sull'input per fare spazio alla
    // bandierina, ricalcolandolo ad ogni cambio di paese/prefisso (anche mentre l'utente
    // digita, per l'auto-detect dal numero). Nel nostro layout la bandierina è spostata a
    // destra via CSS: rispecchiamo qui lo stesso valore su padding-right e azzeriamo il
    // padding-left, ogni volta che la libreria lo tocca.
    const mirrorPhoneInputPadding = () => {
      const left = phoneInputEl.style.paddingLeft;
      if (left && left !== '0px') {
        phoneInputEl.style.paddingRight = left;
        phoneInputEl.style.paddingLeft = '0px';
      }
    };
    new MutationObserver(mirrorPhoneInputPadding).observe(phoneInputEl, {
      attributes: true,
      attributeFilter: ['style'],
    });
    mirrorPhoneInputPadding();

    // Fonte di verità per il paese: il campo indirizzo dedicato a QUESTO telefono (billing_
    // country o shipping_country). In modalità "relax" (vedi isRelaxed) smettiamo invece di
    // imporla e usiamo la bandierina scelta liberamente dall'utente sul widget stesso.
    function getCountryCode() {
      return $(countrySelector).val() || '';
    }

    function isRelaxed() {
      return relaxCountryMatchWhenShippingDiffers && isShippingDifferent();
    }

    // Il menù a tendina della bandierina/prefisso non ha senso come elemento cliccabile
    // quando il paese è vincolato all'indirizzo (verrebbe comunque riportato indietro alla
    // prima selezione manuale, vedi countrychange sotto): resta visibile come indicatore ma
    // non apribile. Torna cliccabile SOLO sul campo billing quando si entra in modalità
    // relax (spedizione a indirizzo diverso), l'unico caso in cui la scelta è davvero libera.
    function updateDropdownLockState() {
      if (wrapper) {
        wrapper.classList.toggle('iti--flag-locked', !isRelaxed());
      }
    }

    function validate() {
      const $field = $(`${phoneSelector}_field`);
      const val = (phoneInputEl.value || '').trim();

      $field.removeClass('woocommerce-invalid woocommerce-validated');
      $field.find('.phone-error').remove();

      // Campo vuoto (WooCommerce gestisce required)
      if (val === '') return;

      // Nota: con separateDialCode il valore del campo è sempre e solo la parte nazionale
      // (senza "+"), quindi la validazione dipende per forza da un paese di riferimento —
      // non essendoci alcun "+" digitato, non ha senso confrontare parsed.country (sarebbe
      // sempre uguale al paese passato). Il vero controllo utile è solo isValid() rispetto
      // al paese di riferimento scelto sotto.
      const countryCode = isRelaxed()
        ? (iti.getSelectedCountry()?.iso2 || '').toUpperCase()
        : getCountryCode();

      let valid;
      try {
        const parsed = parsePhoneNumber(val, countryCode || undefined);
        valid = Boolean(parsed && parsed.isValid());
      } catch (e) {
        valid = false;
      }

      if (!valid) {
        $field.addClass('woocommerce-invalid'); // WooCommerce blocca il checkout

        // Il messaggio "è richiesto un numero locale per X" ha senso solo quando: (1) X è
        // davvero un paese OBBLIGATORIO (modalità normale, imposto dall'indirizzo — in
        // modalità relax nessun paese è richiesto, quindi lì basta sempre il generico) E
        // (2) il numero digitato è plausibile per lunghezza (potrebbe essere un numero vero
        // di un altro paese) — altrimenti, per un numero palesemente incompleto tipo "123",
        // dire "serve un numero locale per l'Italia" è fuorviante: non è un problema di
        // paese, è proprio un numero che non esiste.
        // Messaggio sempre generico: il requisito "serve un numero locale per il paese di
        // spedizione" ora lo spiega il pop-up mostrato al focus sul campo (vedi
        // _pop-up-checkout.js), non ha più senso ripeterlo anche nell'errore inline.
        $field.append(`<span class="phone-error" style="color:#d63638;font-size:12px;">${phoneErrorMessage}</span>`);
      } else {
        $field.addClass('woocommerce-validated');
      }
    }

    // Numero completo in formato internazionale (es. "+393492673312"), da usare SOLO al
    // momento del submit per salvare il prefisso nell'ordine — non usiamo iti.getNumber()
    // perché richiede lo script separato utils.js di intl-tel-input, che questo progetto
    // non carica (getNumber() lancia un errore reale senza). Riusiamo invece
    // parsePhoneNumber (libphonenumber-js), già bundlato per la validazione qui sopra,
    // con la stessa identica logica di risoluzione del paese di riferimento.
    function getFullNumber() {
      const val = (phoneInputEl.value || '').trim();
      if (!val) return '';
      const countryCode = isRelaxed()
        ? (iti.getSelectedCountry()?.iso2 || '').toUpperCase()
        : getCountryCode();
      try {
        const parsed = parsePhoneNumber(val, countryCode || undefined);
        return parsed ? parsed.number : val;
      } catch (e) {
        return val;
      }
    }

    function sync() {
      // In modalità normale, la bandierina resta forzata sul paese di fatturazione: questo
      // numero è quello che il corriere userà per la consegna. In modalità relax non la
      // tocchiamo (l'utente sceglie liberamente) — in entrambi i casi rivalidiamo sempre:
      // validate() sa già mostrare il messaggio giusto (generico in relax, o quando il
      // numero è comunque troppo corto/lungo per essere un tentativo plausibile) invece di
      // uno fuorviante legato a un paese non più vincolante — quindi un errore "numero non
      // valido" resta visibile finché il numero non lo diventa davvero, anche cambiando
      // modalità, invece di sparire e dover essere rigenerato.
      if (!isRelaxed()) {
        const countryCode = getCountryCode();
        if (countryCode) {
          iti.setSelectedCountry(countryCode.toLowerCase());
        }
      }
      updateDropdownLockState();
      validate();
    }

    // Rimandata di un tick: selezionare un paese dal menu del widget (o uscire dal campo)
    // scatena anche gli eventi nativi input/change/focusout su cui è agganciata la
    // validazione telefono GENERICA di WooCommerce (permissiva, controlla solo i caratteri
    // ammessi) — che a quel punto sovrascriverebbe le nostre classi col suo risultato.
    // Eseguendo dopo, con setTimeout, siamo sempre noi ad avere l'ultima parola.
    const deferredValidate = () => setTimeout(validate, 0);

    $(document).on('change', countrySelector, sync);
    $(document).on('blur', phoneSelector, deferredValidate);
    // Scatta quando l'utente sceglie un paese direttamente dal menu a tendina del widget
    // (rilevante soprattutto in modalità relax, dove è l'unico modo per cambiare il paese
    // di riferimento di questo campo) — senza, cambiare bandierina non rivalidava nulla.
    phoneInputEl.addEventListener('countrychange', () => {
      // Fuori dalla modalità relax il paese non è scelto liberamente: se l'utente clicca
      // comunque un'altra bandierina dal menu, la riportiamo subito su quella imposta
      // dall'indirizzo, così la bandierina mostrata non "si disallinea" mai da quella
      // realmente usata per validare (setSelectedCountry ridispatcia countrychange da solo,
      // richiamando questo stesso handler una seconda volta senza ricadere in loop, perché
      // alla seconda chiamata il confronto sotto risulta già uguale).
      if (!isRelaxed()) {
        const expected = getCountryCode();
        const current = (iti.getSelectedCountry()?.iso2 || '').toUpperCase();
        if (expected && current && expected !== current) {
          iti.setSelectedCountry(expected.toLowerCase());
          return;
        }
      }
      deferredValidate();
    });

    sync();

    return { iti, sync, validate, getFullNumber };
  }

  const billingPhoneField = setupDynamicPhoneField('#billing_phone', '#billing_country', {
    relaxCountryMatchWhenShippingDiffers: true,
  });
  const shippingPhoneField = setupDynamicPhoneField('#phone_shipping', '#shipping_country');

  // Il toggle "Spedisci a un indirizzo diverso?" cambia se billing_phone deve corrispondere
  // al paese di fatturazione o no (vedi relaxCountryMatchWhenShippingDiffers sopra): quando
  // l'utente lo spunta/despunta va risincronizzato subito, non solo al prossimo cambio di
  // paese — sync() forza di nuovo la bandierina sul paese di fatturazione quando si torna
  // alla modalità normale (checkbox deselezionata), e rivalida in entrambi i casi.
  if (billingPhoneField) {
    $(document).on('change', '#ship-to-different-address-checkbox', () => billingPhoneField.sync());
  }

  // Con separateDialCode il valore "grezzo" del campo (quello che WooCommerce salva
  // nell'ordine) contiene solo le cifre nazionali, senza prefisso — il prefisso è mostrato
  // solo visivamente accanto alla bandierina, mai dentro al value effettivo. Risultato:
  // l'ordine, la vista admin e le email amministrative mostravano il numero senza "+39".
  // Fix: subito prima dell'invio (checkout_place_order, l'hook nativo WC per questo tipo di
  // intervento) sostituiamo il value con il numero completo in formato internazionale via
  // iti.getNumber(). Ripristiniamo il valore digitato dall'utente se l'ordine fallisce
  // (checkout_error), così un eventuale nuovo tentativo riparte da un campo pulito.
  let billingPhoneRawBackup = null;
  let shippingPhoneRawBackup = null;

  // IMPORTANTE: WC core lancia questo evento con $form.triggerHandler('checkout_place_order', ...)
  // sul form stesso (wp-content/plugins/woocommerce/assets/js/frontend/checkout.js:772) — a
  // differenza di trigger(), triggerHandler() NON fa bubbling: un handler agganciato a
  // document.body non viene mai chiamato. Va agganciato direttamente su form.checkout.
  $('form.checkout').on('checkout_place_order', function () {
    if (billingPhoneField) {
      billingPhoneRawBackup = $('#billing_phone').val();
      const fullNumber = billingPhoneField.getFullNumber();
      if (fullNumber) $('#billing_phone').val(fullNumber);
    }
    if (shippingPhoneField) {
      shippingPhoneRawBackup = $('#phone_shipping').val();
      const fullNumber = shippingPhoneField.getFullNumber();
      if (fullNumber) $('#phone_shipping').val(fullNumber);
    }
    return true;
  });

  $(document.body).on('checkout_error', function () {
    if (billingPhoneRawBackup !== null) $('#billing_phone').val(billingPhoneRawBackup);
    if (shippingPhoneRawBackup !== null) $('#phone_shipping').val(shippingPhoneRawBackup);
  });

  // Forza refresh checkout quando cambiano i campi che influenzano la spedizione
  const triggerSelectors = '#shipping_country, #shipping_state, #shipping_postcode, #billing_country, #billing_state, #billing_postcode';
  $(document).on('change', triggerSelectors, function () {
    // Se i campi di spedizione sono nascosti, sincronizza da billing -> shipping
    const $shipWrap = $('.woocommerce-shipping-fields');
    if (!$shipWrap.length || $shipWrap.is(':hidden')) {
      const bc = $('#billing_country').val();
      if ($('#shipping_country').length && bc) {
        $('#shipping_country').val(bc).trigger('change.select2');
      }
      const bs = $('#billing_state').val();
      if ($('#shipping_state').length && bs) {
        $('#shipping_state').val(bs).trigger('change.select2');
      }
      const bp = $('#billing_postcode').val();
      if ($('#shipping_postcode').length && bp) {
        $('#shipping_postcode').val(bp);
      }
    }
    $('body').trigger('update_checkout');
  });

  // Se ci sono quantità editabili nel checkout, forza refresh al cambio
  $(document).on('change', '.woocommerce-checkout .qty', function () {
    $('body').trigger('update_checkout');
  });

  // Forza un primo refresh all’ingresso (utile con autocompilazione)
  $('body').trigger('update_checkout');

  const relatedSwiper = new Swiper('.custom-cart__slider .swiper', {
        slidesPerView: 1.15,
        spaceBetween: 8,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            500: {
                slidesPerView: 1.15,
                spaceBetween: 8,
            },
            768: {
                slidesPerView: 2.3,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
            }
        }
    });

    document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.wc-has-real-span').forEach(function(wrapper) {

        const select = wrapper.querySelector('select');
        const label  = select?.getAttribute('data-placeholder-span');

        if (!select || !label) return;

        // Evita duplicazioni
        if (wrapper.querySelector('.fake-span')) return;

        // Crea lo span
        const span = document.createElement('span');
        span.className = 'fake-span';
        span.textContent = label;
        wrapper.appendChild(span);

        // Toggle visibilità quando il select cambia
        const toggle = () => {
            if (select.value === '') {
                span.classList.remove('hidden');
            } else {
                span.classList.add('hidden');
            }
        };

        select.addEventListener('change', toggle);
        select.addEventListener('blur', toggle);

        // Stato iniziale
        toggle();
    });

});


});